import { useQuery } from '@tanstack/react-query';
import req from 'utils/req';

const fetchHost = async (prettyUrlOrId: string) => {
  return req(`${URL_API_HOST}/api/v1/hosts/${prettyUrlOrId}`).get();
};

function useHost(prettyUrlOrId: string) {
  const query = useQuery({
    queryKey: ['host', prettyUrlOrId],
    queryFn: () => fetchHost(prettyUrlOrId),
    onError: (error: any) => error,
    retry: 0,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
  });
  return {
    data: query.data,
    loading: query.isLoading,
    error: query.error,
  };
}

export default useHost;
